import React from 'react';
import EllipseSvg from '@/assets/Ellipse.svg';

interface EclipseProps {
  width?: number;
  height?: number;
}

const Ellipse = ({ width = 32, height = 32 }: EclipseProps) => (
  <img src={EllipseSvg} style={{ width: width, height: height }} aria-hidden="true" alt="" />
);

export default Ellipse;
